import axios from "axios";

//Common
import {
  BASE_NAME,
  HEADER_MANUTENCAO,
  HEADER_REQUISICAO_AUTOMATICA,
} from "@/common/constantes";

//Util
import {
  CHAVE_MENSAGEM_MANUTENCAO,
  fn_setManutencaoAtiva,
} from "@/frontend/utils/manutencao";
import {
  fn_getIdTelaAtual,
  fn_getTokenUsuario,
  fn_getUsuario,
} from "@/frontend/utils/sessao";
import {
  fn_getBaseUrlAxios,
  fn_getDescricaoAmbiente,
} from "@/frontend/utils/env";
import { fn_isRequisicaoAutomatica } from "@/frontend/utils/interacaoUsuario";

const baseURL = fn_getBaseUrlAxios();

console.log("#Ambiente ", fn_getDescricaoAmbiente(), " BASE URL: ", baseURL);

const api = axios.create({
  baseURL: baseURL,
});

api.defaults.headers.post["Content-Type"] = "application/json";

//REQUEST: - Adiciona o token no cabeçalho
//         - Envia o id_tenant em todas as requisições GET, POST, PUT e PATCH
//         - Informa a tela aberta no cabeçalho, para o servidor gravar no log de alteração
api.interceptors.request.use(
  (config) => {
    const sessaoUsuarioData = sessionStorage.getItem("sessaoUsuario");
    const sessaoUsuario = sessaoUsuarioData
      ? JSON.parse(sessaoUsuarioData)
      : null;

    if (sessaoUsuario) {
      const usuarioLogado = fn_getUsuario(sessaoUsuario);

      const token = fn_getTokenUsuario(sessaoUsuario);
      if (token) {
        config.headers.Authorization = `Bearer ${token}`; // Adiciona o token no cabeçalho
      }

      //Tela que originou a requisição (apenas informativo para o log de alteração)
      const idTela = fn_getIdTelaAtual(sessaoUsuario);
      if (idTela) {
        config.headers["x-id-tela"] = idTela;
      }

      //Requisição sem clique ou tecla do usuário nos últimos segundos (consulta de usuários conectados)
      if (fn_isRequisicaoAutomatica()) {
        config.headers[HEADER_REQUISICAO_AUTOMATICA] = "S";
      }

      const idTenant = usuarioLogado?.id_tenant;
      if (idTenant) {
        //Adiciona o id_tenant e id_usuario_login no req.query / body de todas as requisições
        const camposSessao = {
          id_tenant: idTenant,
          id_usuario_login: usuarioLogado.id,
        };

        config.params = {
          ...config.params,
          ...camposSessao,
        };

        //Adiciona o id_tenant no corpo de todas as requisições POST, PUT e PATCH
        if (
          ["POST", "PUT", "PATCH"].includes(config.method.toUpperCase()) &&
          !(config.data instanceof FormData)
        ) {
          if (config.data && typeof config.data === "object") {
            config.data = {
              ...config.data,
              ...camposSessao,
            };
          } else if (!config.data) {
            config.data = { ...camposSessao };
          }
        }
      }
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

//Retorna se a resposta do servidor indica o bloqueio de manutenção ligado
function isRespostaManutencao(response) {
  return response?.headers?.[HEADER_MANUTENCAO.toLowerCase()] == "S";
}

//RESPONSE: - Mostra/esconde a tarja do bloqueio de manutenção (usuário system)
//          - Interceptor para erros
api.interceptors.response.use(
  (response) => {
    fn_setManutencaoAtiva(isRespostaManutencao(response));
    return response; // Retorna a resposta se estiver OK
  },
  (error) => {
    //Requisição que não trata a sessão (ex: aviso da saída do sistema, api_logout): só devolve o erro
    if (error.config?.ignorarTratamentoSessao) {
      return Promise.reject(error);
    }

    //Sistema em manutenção: encerra a sessão e apresenta a página de manutenção com a mensagem do servidor
    if (error.response?.status == 503 && isRespostaManutencao(error.response)) {
      console.log("### SISTEMA EM MANUTENCAO ###");
      sessionStorage.removeItem("sessaoUsuario");
      sessionStorage.setItem(
        CHAVE_MENSAGEM_MANUTENCAO,
        typeof error.response.data == "string" ? error.response.data : "",
      );
      window.location.href = `${BASE_NAME || ""}/manutencao`;
    } else if (error.response && error.response.status === 401) {
      console.log("### SESSAO EXPIRADA ###");
      sessionStorage.removeItem("sessaoUsuario");
      window.location.href = `${BASE_NAME || ""}/sessao_expirada`;
    }

    return Promise.reject(error); // Propaga o erro para tratamentos adicionais
  },
);

export default api;
